<div class="modal-header">
    <h3>Tạo mới {{typeName}}</h3>
</div>
<div class="modal-body">
    <div class="example-form d-flex flex-column" [formGroup]="editForm">
        <div class="row">
            <div class="cms-container col-lg-12">
                <nz-form-label>Công ty bảo hiểm<span class="red">(*)</span></nz-form-label>
                <dropdown [value]="editForm.value.productOwnerId" [list]="issuers" [disabled]="issuerId !== null"
                    (result)="patchForm('productOwnerId', $event.id)" [title]="'Chọn công ty bảo hiểm'">
                </dropdown>
                <app-error-text [isDisplay]="isSaved && editForm.get('productOwnerId')?.errors?.required"
                    [message]="'Công ty bảo hiểm bắt buộc nhập.'">
                </app-error-text>
            </div>
            <div class="cms-container col-lg-12">
                <nz-form-item>
                    <nz-form-label>Tên sản phẩm<span class="red">*</span> </nz-form-label>
                    <nz-input-group>
                        <input type="text" nz-input formControlName="name">
                    </nz-input-group>
                    <app-error-text [isDisplay]="isSaved && editForm.get('name')?.errors?.required"
                        [message]="'Tên sản phẩm bắt buộc nhập.'">
                    </app-error-text>
                </nz-form-item>
            </div>
            <div class="cms-container col-lg-12">
                <nz-form-item>
                    <nz-form-label>Tên chương trình chính<span class="red">*</span> </nz-form-label>
                    <nz-input-group>
                        <input type="text" nz-input formControlName="programName">
                    </nz-input-group>
                    <app-error-text [isDisplay]="isSaved && editForm.get('programName')?.errors?.required"
                        [message]="'Tên chương trình chính bắt buộc nhập.'">
                    </app-error-text>
                </nz-form-item>
            </div>
        </div>
        <div class="group-btn">
            <button class="btn common__btn" (click)="save()">Tạo mới</button>
            <button class="btn btn__cancel" (click)="cancel()">Hủy bỏ</button>
        </div>
    </div>
</div>